import {  checkBusinessName,} from './actions/LoginActions';
import { subDomainUrlRedirection } from '../../actions/utilAction';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Loader from '../../img/loader.gif';
// var macaddress = require('macaddress');
import Favicon from 'react-favicon';
import Login from './login';
import UpdateLoginUserPassword from './login_updatePassword';
import LogoImageViewer from '../../components/logoImageViewer'; 

const loginComponents = {
  'login': Login,
  'updatePassword': UpdateLoginUserPassword,
};

class LoginIndex extends Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedComponent: 'login',
      loginUserId: null,
      errorMessage: '',
      successMessage: '',
    };
    this.redirectToLogin = this.redirectToLogin.bind(this);
  }

  componentWillMount() {
    let subdomain = subDomainUrlRedirection();
    if (subdomain) {
      this.props.checkBusinessName(subdomain);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.loginResponse && nextProps.loginResponse !== this.props.loginResponse) {
      if (nextProps.loginResponse.statusCode === 205) {
        this.setState({
          selectedComponent: 'updatePassword',
          loginUserId: nextProps.loginResponse.data || null,
        });
      }
    }
    if (nextProps.updateLoginPasswordResponse && nextProps.updateLoginPasswordResponse !== this.props.updateLoginPasswordResponse) {
      if (nextProps.updateLoginPasswordResponse.statusCode === 200) {
        this.setState({
          selectedComponent: 'login',
          loginUserId: null,
        });
      }
    }

    if (nextProps.errorMessage !== this.props.errorMessage) {
      this.setState({
        errorMessage: nextProps.errorMessage,
      });
    }

    if (nextProps.successMessage !== this.props.successMessage) {
      this.setState({
        successMessage: nextProps.successMessage,
      });
    }

  }

  redirectToLogin() {
    this.setState({
      selectedComponent: 'login',
      loginUserId: null,
      successMessage: null,
      errorMessage: null,
    });
  }

  render() {
      // used for displaying different components ...
      let selectedComponent = this.state.selectedComponent;
      let CurrentComponent = loginComponents[selectedComponent];
      const loginHeaderComponent = (<h3>Login as Agency <i className="flaticon-building"></i></h3>);

    const { authenticatingToken, loaderBusinessToken, businessNameCheck } = this.props;
    let logoUrl = this.props.organizationLogoBase64 && `data:image/png;base64,${this.props.organizationLogoBase64}`;
    let faviconUrl = this.props.organizationFavicon || '';

    if (loaderBusinessToken) {
      return (
        <div className="login_bg">
          <div className="loaderwrap">
            <div className="loadermain">
              <img src={Loader} alt="" />
            </div>
          </div>
        </div>
      );
    }
    if (!businessNameCheck) { // {this.props.businessCheckMessage}
      return (
        <div className="hgt100">
          <div className="errorwrap">
            <div className="errorblock">
              <div className="errorbox domainfound">
                <h3 className="title-404">Invalid domain name!</h3>
                <p>You have been click on a link that can not be found. <span className="block">Please check the url to correct domain name {/* or
  go to <NavLink exact to='/login'>main page</NavLink>*/} and see if you can locate what you are looking for.</span></p>
              </div>
            </div>
          </div>
          {/* <a href="mailto:admin@smarthealth.net.in" className="gobackbtn wddomain">Contact Admin</a> */}
          {/* <NavLink className="gobackbtn wddomain" exact to='/login'>Contact Admin</NavLink>*/}
        </div>
      );
    }
    if (authenticatingToken) {
      return (
        <div className="login_bg">
          <div className="loaderwrap">
            <div className="loadermain">
              <img src={Loader} alt="" />
            </div>
          </div>
        </div>);
    }
    return (
      <div className="login_bg_WithGradient">
        <div className="login-wrapper">
          <Favicon url={faviconUrl} />
          <div className="loginlogo">
          <LogoImageViewer isLoginPage={true} logoUrl={logoUrl} businessName={this.props.businessName} />
          </div>
          <CurrentComponent
            {...this.props}
            successMessage={this.state.successMessage}
            errorMessage={this.state.errorMessage}
            loginUserId={this.state.loginUserId}
            redirectToLogin={this.redirectToLogin}
            loginHeaderComponent={loginHeaderComponent}/>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    authenticatingToken: state.login.authenticatingToken,
    loaderBusinessToken: state.login.loaderBusinessToken,
    businessNameCheck: state.login.businessNameCheck,
    businessName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
    organizationLogoBase64: state.login.organizationDetails && state.login.organizationDetails.logoBase64,
    organizationFavicon: state.login.organizationDetails && state.login.organizationDetails.favicon,
    errorMessage: state.login.errorMessage,
    successMessage: state.login.successMessage,
    loginResponse: state.login.loginResponse,
    updateLoginPasswordResponse: state.login.updateLoginPasswordResponse,
  };
}

export default connect(mapStateToProps, {
  checkBusinessName,
})(LoginIndex);




// WEBPACK FOOTER //
// ./src/modules/logins/index.js